/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum FittingState {
  Continue = 'Continue',
  Discontinue = 'Discontinue'
}
